import React from 'react';

function ValidationErrorLabel(props) {
  const { message, color = 'red', fontSize = '12px' } = props;

  return <span style={{ color, fontSize }}>{message}</span>;
}

export default ValidationErrorLabel;
